import { convertToBoolean } from "@/utils/types";
import { getIndexFromType, getIndexFromUrl } from "@/utils/css-utils";
import spinSrc from "@/assets/image360spin.json";
import videoSrc from "@/assets/videoicon.json";
import fullScreenIconCloseSrc from "@/assets/image_fullscreeniconclose.json";
import fullScreenIconOpenSrc from "@/assets/image_fullscreeniconopen.json";
import hintImagesSrc from "@/assets/hint_images.json";

export const uploadOptionsConverter = (collapseOptions, settings, spinControl) => {
  const formattedSettings = settings
    .replace(" ", "")
    .split(";")
    .filter((e) => e !== "")
    .map((e) => {
      const idx = e.indexOf(":");
      return {
        parameter: e.substring(0, idx).trim(),
        value: convertToBoolean(e.substring(idx + 1).trim()),
      };
    });

  return collapseOptions
    .map((o) => Object.assign(o))
    .map((o) => {
      if (o.hasChildCollapse === false) {
        o.items = o.items.map((i) => {
          if (spinControl.spinControlPanelStatus && i.parameter === "spin.control.panel") {
            i.eventClick = true;
            i.status = spinControl.spinControlPanelStatus;
            i.defaultButtons = spinControl.spinControlSelectedButtons;
            i.defaultIcons = spinControl.spinControlSelectedIconsStyle;
            i.defaultPosition = spinControl.spinControlSelectedPosition;
            i.defaultBackground = spinControl.spinControlBackground;
            i.defaultIconsColor = spinControl.spinControlIconsColor;
            i.iconsSize = spinControl.spinControlIconsSize;
          }
          formattedSettings.forEach((s) => {
            if (s.parameter === i.parameter) {
              i.eventClick = true;
              i.default = s.value;
              console.log(i);
            }
          });
          return i;
        });

        if (o.collapseChildOptions) {
          o.collapseChildOptions = o.collapseChildOptions.map((innerO) => {
            innerO.items = innerO.items.map((i) => {
              if (spinControl.spinControlPanelStatus && i.parameter === "spin.control.panel") {
                i.eventClick = true;

                i.status = spinControl.spinControlPanelStatus;
                i.defaultButtons = spinControl.spinControlSelectedButtons;
                i.defaultIcons = spinControl.spinControlSelectedIconsStyle;
                i.defaultPosition = spinControl.spinControlSelectedPosition;
                i.defaultBackground = spinControl.spinControlBackground;
                i.defaultIconsColor = spinControl.spinControlIconsColor;
                i.iconsSize = spinControl.spinControlIconsSize;
              }

              formattedSettings.forEach((s) => {
                if (s.parameter === i.parameter) {
                  i.eventClick = true;
                  i.default = s.value;
                  console.log(i);
                }
              });

              return i;
            });
            return innerO;
          });
        }
      } else if (o.hasChildCollapse === true) {
        o.collapseChildOptions = o.collapseChildOptions.map((innerO) => {
          innerO.items = innerO.items.map((i) => {
            if (spinControl.spinControlPanelStatus && i.parameter === "spin.control.panel") {
              i.eventClick = true;

              i.status = spinControl.spinControlPanelStatus;
              i.defaultButtons = spinControl.spinControlSelectedButtons;
              i.defaultIcons = spinControl.spinControlSelectedIconsStyle;
              i.defaultPosition = spinControl.spinControlSelectedPosition;
              i.defaultBackground = spinControl.spinControlBackground;
              i.defaultIconsColor = spinControl.spinControlIconsColor;
              i.iconsSize = spinControl.spinControlIconsSize;
            }
            formattedSettings.forEach((s) => {
              if (s.parameter === i.parameter) {
                i.eventClick = true;
                i.default = s.value;
              }
            });
            return i;
          });
          return innerO;
        });
      }
      return o;
    });
};

export const uploadOptionsJSConverter = (collapseOptions, settings) =>
  collapseOptions
    .map((o) => Object.assign(o))
    .map((o) => {
      if (o.hasChildCollapse === false) {
        o.items = o.items.map((i) => {
          if (i.type === "ScriptInput" && i.parameter === "type") {
            i.eventClick = true;
            i.default = settings.scriptType;
            i.defaultComponents = settings.scriptComponents;
          }
          return i;
        });
      }
      return o;
    });

export const uploadOptionsCSSConverter = (collapseOptions, settings) =>
  collapseOptions
    .map((o) => Object.assign(o))
    .map((o) => {
      if (o.hasChildCollapse === false) {
        o.items = o.items.map((i) => {
          settings.forEach((s) => {
            if (
              s.type === "hinticons" &&
              ((Array.isArray(i.type) && i.type.includes(s.hiddenType)) ||
                (typeof i.type === "string" && i.type.includes(s.hiddenType))) &&
              s.parameter === i.parameter
            ) {
              i.eventClick = true;
              i.default = getIndexFromType(hintImagesSrc, s.hiddenType);
              return;
            }

            if (
              s.type === "arrows-icon" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "opacity"
            ) {
              i.eventClick = true;
              i.default = parseFloat(s.value) * 100;
              return;
            }

            if (
              s.type === "arrows" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "height"
            ) {
              i.eventClick = true;
              i.default = parseInt(s.value);
              return;
            }

            if (
              s.type === "fullscreen-icon-open" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "-webkit-mask-image"
            ) {
              i.eventClick = true;
              i.default = getIndexFromUrl(fullScreenIconOpenSrc, s.value);
              return;
            }

            if (
              s.type === "fullscreen-icon-close" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "-webkit-mask-image"
            ) {
              i.eventClick = true;
              i.default = getIndexFromUrl(fullScreenIconCloseSrc, s.value);
              return;
            }

            if (
              s.type === "spin360" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "background-image"
            ) {
              i.eventClick = true;
              i.default = getIndexFromUrl(spinSrc, s.noIconValue || s.value);
              return;
            }

            if (
              s.type === "spin360" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "background-color"
            ) {
              i.eventClick = true;
              i.default = s.value;
              i.rgba = true;
              return;
            }

            if (
              s.type === "videoicon" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "background-image"
            ) {
              i.eventClick = true;
              i.default = getIndexFromUrl(videoSrc, s.value);
              return;
            }

            if (
              s.type === "videoicon" &&
              s.type === i.type &&
              s.parameter === i.parameter &&
              s.parameter === "background-color"
            ) {
              i.eventClick = true;
              i.default = s.value;
              i.rgba = true;
              return;
            }

            if (s.parameter === "inlineModeSMV" && s.parameter === i.parameter) {
              i.eventClick = true;
              i.default = s.value;
              return;
            }

            if (s.type === i.type && s.parameter === i.parameter) {
              i.eventClick = true;
              i.default = s.value.replace("px", "");
              return;
            }
          });
          return i;
        });
      } else if (o.hasChildCollapse === true) {
        o.collapseChildOptions = o.collapseChildOptions.map((innerO) => {
          innerO.items = innerO.items.map((i) => {
            settings.forEach((s) => {
              if (
                s.type === "hinticons" &&
                ((Array.isArray(i.type) && i.type.includes(s.hiddenType)) ||
                  (typeof i.type === "string" && i.type.includes(s.hiddenType))) &&
                s.parameter === i.parameter
              ) {
                i.eventClick = true;
                i.default = getIndexFromType(hintImagesSrc, s.hiddenType);
                return;
              }

              if (
                s.type === "arrows-icon" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "opacity"
              ) {
                i.eventClick = true;
                i.default = parseFloat(s.value) * 100;
                return;
              }

              if (
                s.type === "arrows" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "height"
              ) {
                i.eventClick = true;
                i.default = parseInt(s.value);
                return;
              }

              if (
                s.type === "fullscreen-icon-open" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "-webkit-mask-image"
              ) {
                i.eventClick = true;
                i.default = getIndexFromUrl(fullScreenIconOpenSrc, s.value);
                return;
              }

              if (
                s.type === "fullscreen-icon-close" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "-webkit-mask-image"
              ) {
                i.eventClick = true;
                i.default = getIndexFromUrl(fullScreenIconCloseSrc, s.value);
                return;
              }

              if (
                s.type === "fullscreen-icon-size" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "width"
              ) {
                i.eventClick = true;
                i.default = parseInt(s.value.replace("px", ""));
                return;
              }

              if (
                s.type === "spin360" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "background-image"
              ) {
                i.eventClick = true;
                i.default = getIndexFromUrl(spinSrc, s.noIconValue || s.value);
                return;
              }

              if (
                s.type === "spin360" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "background-color"
              ) {
                i.eventClick = true;
                i.default = s.value;
                i.rgba = true;
                return;
              }

              if (
                s.type === "videoicon" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "background-image"
              ) {
                i.eventClick = true;
                i.default = getIndexFromUrl(videoSrc, s.value);
                return;
              }

              if (
                s.type === "videoicon" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "background-color"
              ) {
                i.eventClick = true;
                i.default = s.value;
                i.rgba = true;
                return;
              }

              if (
                s.type === "thumbnails-box-shadows" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "box-shadow"
              ) {
                i.eventClick = true;
                i.default = s.value;

                const source = s.value;
                const horizontalIndex = source.indexOf(" ");
                const horizontal = source.substr(0, horizontalIndex);
                const sourceWithoutH = source.substr(horizontalIndex).trim();
                const verticalIndex = sourceWithoutH.indexOf(" ");
                const vertical = sourceWithoutH.substr(0, verticalIndex);
                const sourceWithoutV = sourceWithoutH.substr(verticalIndex).trim();
                const blurIndex = sourceWithoutV.indexOf(" ");
                const blurValue = sourceWithoutV.substr(0, blurIndex);
                const sourceWithoutBlur = sourceWithoutV.substr(blurIndex).trim();
                const stretchingIndex = sourceWithoutBlur.indexOf(" ");
                const stretching = sourceWithoutBlur.substr(0, stretchingIndex);
                const sourceWithoutStretching = sourceWithoutBlur.substr(stretchingIndex).trim();
                let inset = false;
                let color = "";
                const colorIndex = sourceWithoutStretching.indexOf(" ");
                const insetIndex =
                  sourceWithoutStretching.indexOf("inset") !== -1
                    ? sourceWithoutStretching.lastIndexOf(" ")
                    : null;
                if (insetIndex !== null) {
                  inset = true;
                  color = sourceWithoutStretching.substr(0, insetIndex);
                } else {
                  color = sourceWithoutStretching;
                }

                i.defaultHorizontal = horizontal;
                i.defaultVertical = vertical;
                i.defaultBlur = blurValue;
                i.defaultStretching = stretching;
                i.defaultInset = inset;
                i.defaultColor = color;
                return;
              }

              if (
                s.type === "thumbnails-active-box-shadows" &&
                s.type === i.type &&
                s.parameter === i.parameter &&
                s.parameter === "box-shadow"
              ) {
                i.eventClick = true;
                i.default = s.value;

                const source = s.value;
                const horizontalIndex = source.indexOf(" ");
                const horizontal = source.substr(0, horizontalIndex);
                const sourceWithoutH = source.substr(horizontalIndex).trim();
                const verticalIndex = sourceWithoutH.indexOf(" ");
                const vertical = sourceWithoutH.substr(0, verticalIndex);
                const sourceWithoutV = sourceWithoutH.substr(verticalIndex).trim();
                const blurIndex = sourceWithoutV.indexOf(" ");
                const blurValue = sourceWithoutV.substr(0, blurIndex);
                const sourceWithoutBlur = sourceWithoutV.substr(blurIndex).trim();
                const stretchingIndex = sourceWithoutBlur.indexOf(" ");
                const stretching = sourceWithoutBlur.substr(0, stretchingIndex);
                const sourceWithoutStretching = sourceWithoutBlur.substr(stretchingIndex).trim();
                let inset = false;
                let color = "";
                const colorIndex = sourceWithoutStretching.indexOf(" ");
                const insetIndex =
                  sourceWithoutStretching.indexOf("inset") !== -1
                    ? sourceWithoutStretching.lastIndexOf(" ")
                    : null;
                if (insetIndex !== null) {
                  inset = true;
                  color = sourceWithoutStretching.substr(0, insetIndex);
                } else {
                  color = sourceWithoutStretching;
                }

                i.defaultHorizontal = horizontal;
                i.defaultVertical = vertical;
                i.defaultBlur = blurValue;
                i.defaultStretching = stretching;
                i.defaultInset = inset;
                i.defaultColor = color;
                return;
              }

              if (s.type === i.type && s.parameter === i.parameter) {
                i.eventClick = true;
                i.default = s.value.replace("px", "");
                return;
              }
            });
            return i;
          });
          return innerO;
        });
      }
      return o;
    });
